/*
 * Kickflip → nota del carrello + attributo "Biglietto regalo"
 * Dopo ogni modifica al carrello (add / change / update / clear) legge il carrello
 * e scrive le properties di tutte le righe create dal configuratore Kickflip,
 * così come arrivano:
 *   - nella nota del carrello (→ riquadro "Note" dell'ordine)
 *   - nell'attributo del carrello ATTRIBUTE_NAME (→ "Dettagli aggiuntivi" dell'ordine)
 * Il testo scritto dal cliente viene conservato: il blocco Kickflip sta tra due
 * marcatori e viene riscritto ogni volta. Nella casella visibile dell'attributo il
 * cliente vede solo il proprio testo; il blocco viene riaggiunto all'invio del form.
 * Le righe del carrello non vengono toccate.
 */
(function () {
  "use strict";

  var WRITE_NOTE = true;                    // false = non scrivere nella nota del carrello
  var ATTRIBUTE_NAME = "Biglietto regalo";  // "" = non scrivere in nessun attributo
  var BLOCK_START = "=== CONFIGURATORE ===";
  var BLOCK_END = "=== FINE CONFIGURATORE ===";
  var SHOW_DESIGN_ID = true;

  // Voci visibili della riga: Kickflip le mette in _mczr_attributes ([{key, value}])
  function kickflipEntries(props) {
    if (!props || !Object.keys(props).some(function (k) { return k.indexOf("_mczr") === 0; })) return null;
    var list;
    if (typeof props._mczr_attributes === "string") {
      try { list = JSON.parse(props._mczr_attributes) || []; } catch (e) { list = []; }
    } else {
      list = Object.keys(props).map(function (k) { return { key: k, value: props[k] }; });
    }
    return list.filter(function (a) { return a && a.key && String(a.key).charAt(0) !== "_"; });
  }

  function buildSummary(cart) {
    var blocks = [];
    var n = 0;
    (cart.items || []).forEach(function (item) {
      var entries = kickflipEntries(item.properties);
      if (!entries || !entries.length) return;
      var props = item.properties || {};
      var lines = ["Riga " + (++n) + ": " + item.product_title + " × " + item.quantity];
      if (SHOW_DESIGN_ID && props._mczr_designId) lines.push("ID design: " + props._mczr_designId);
      entries.forEach(function (a) { lines.push(a.key + ": " + a.value); });
      blocks.push(lines.join("\n"));
    });
    return blocks.join("\n\n");
  }

  // Sostituisce il blocco tra i marcatori, lasciando intatto il resto del testo
  function mergeBlock(text, summary) {
    text = text || "";
    var start = text.indexOf(BLOCK_START);
    var end = text.indexOf(BLOCK_END);
    var clean = start === -1 ? text
      : text.slice(0, start) + (end === -1 ? "" : text.slice(end + BLOCK_END.length));
    clean = clean.replace(/\s+$/, "");
    if (!summary) return clean;
    return (clean ? clean + "\n\n" : "") + BLOCK_START + "\n" + summary + "\n" + BLOCK_END;
  }

  function stripBlock(text) { return mergeBlock(text, ""); }

  // ─── CASELLA VISIBILE DELL'ATTRIBUTO ───

  function attrFields() {
    if (!ATTRIBUTE_NAME) return [];
    var name = "attributes[" + ATTRIBUTE_NAME + "]";
    return Array.prototype.filter.call(
      document.querySelectorAll("textarea, input"),
      function (el) { return el.name === name; }
    );
  }

  // Il cliente vede solo il proprio testo
  function cleanFields() {
    attrFields().forEach(function (el) {
      var v = stripBlock(el.value);
      if (v !== el.value) el.value = v;
    });
  }

  var lastSummary = null;

  // All'invio del form del carrello il blocco viene riaggiunto al valore inviato
  document.addEventListener("submit", function (e) {
    if (lastSummary === null) return;
    attrFields().forEach(function (el) {
      if (el.form === e.target) el.value = mergeBlock(el.value, lastSummary);
    });
  }, true);

  // ─── SINCRONIZZAZIONE ───

  var origFetch = window.fetch;
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || "/";
  var MUTATION_RE = /\/cart\/(add|change|update|clear)(\.js)?\/?$/;

  function isMutation(url) {
    try { return MUTATION_RE.test(new URL(url, location.href).pathname); } catch (e) { return false; }
  }

  var running = false, again = false;

  function sync() {
    if (running) { again = true; return; }
    running = true;
    origFetch.call(window, ROOT + "cart.js", { headers: { "Accept": "application/json" } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var summary = buildSummary(cart);
        lastSummary = summary;
        var payload = {};

        if (WRITE_NOTE) {
          var note = mergeBlock(cart.note, summary);
          if (note !== (cart.note || "")) payload.note = note;
        }
        if (ATTRIBUTE_NAME) {
          var current = (cart.attributes || {})[ATTRIBUTE_NAME] || "";
          var value = mergeBlock(current, summary); // "" = rimuove l'attributo
          if (value !== current) { payload.attributes = {}; payload.attributes[ATTRIBUTE_NAME] = value; }
        }

        cleanFields();
        if (!Object.keys(payload).length) return;
        return origFetch.call(window, ROOT + "cart/update.js", {
          method: "POST",
          headers: { "Content-Type": "application/json", "Accept": "application/json" },
          body: JSON.stringify(payload)
        });
      })
      .catch(function (e) { console.warn("[kickflip-note]", e); })
      .then(function () {
        running = false;
        if (again) { again = false; sync(); }
      });
  }

  var timer;
  function scheduleSync() { clearTimeout(timer); timer = setTimeout(sync, 300); }

  // Hook fetch: dopo ogni modifica riuscita al carrello
  if (origFetch) {
    window.fetch = function (input, init) {
      var url = typeof input === "string" ? input : (input && (input.href || input.url));
      var p = origFetch.apply(this, arguments);
      if (isMutation(url)) p.then(function (res) { if (res.ok) scheduleSync(); }, function () {});
      return p;
    };
  }

  // Hook XMLHttpRequest
  var origOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    if (isMutation(url)) {
      this.addEventListener("load", function () { if (this.status >= 200 && this.status < 300) scheduleSync(); });
    }
    return origOpen.apply(this, arguments);
  };

  // Al caricamento: pulisce la casella visibile e sincronizza
  function init() { cleanFields(); scheduleSync(); }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();

  // Per test da console: KickflipNote.sync()
  window.KickflipNote = { sync: sync, buildSummary: buildSummary };
})();
